import { BackgroundAction } from '../BackgroundAction'
import { taxBackgroundAction } from './api'

export const ExportBackgroundAction = new BackgroundAction({
  api: taxBackgroundAction,
})
